export const environment = {
    production: false,
    apiBaseUrl: '/api/',
    // Platform Admin AI Assist Service. Relative path routed to the shared
    // service instance by the reverse proxy (published) / ng-serve proxy (local).
    aiAssistBaseUrl: '/admin-ai-assist/',
    // Host of the games web app for this environment. A game template's GameUrl
    // is always just this host (the app routes by gameKind), so the field is
    // readonly in the editor and derived from here.
    gamesAppBaseUrl: 'https://app-dev-games.shopiz.io',
    // S3 bucket holding site-template builds for this environment. Used as the fixed
    // bucket when adding a site template (base prefix is derived from the template ID).
    siteTemplatesBucket: 'platform-dev-477075396651-eu-central-1-an',
};
